"use client";

import { componentRenderers } from "@/constants";
import { TInquiriesDetailsData } from "@/interfaces";
import { Suspense, useEffect, useRef } from "react";
import AppContainer from "../appContainer";
import { cn } from "@/lib";
import { FlexCenter } from "../ui";
import SaveBillFromInquiry from "@/components/bills/saveBillFromInquiry";
import VehicleComprehensiveReport from "@/components/inquiryDetails/vehicles/vehicleComprehensiveReport";

const InquiryDetailsWrapper = ({
  purchasedInquiryData,
}: {
  purchasedInquiryData: TInquiriesDetailsData;
}) => {
  const matched = componentRenderers.find((resolver) =>
    resolver.guard(purchasedInquiryData),
  );
  const vehiclePurchase = purchasedInquiryData as any;
  const isVehicleReport = vehiclePurchase?.inquery?.flag === "vehicle_comprehensive_report";
  const vehicleResult = vehiclePurchase?.data?.data;
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    sectionRef.current?.scrollIntoView({ behavior: "smooth" });
  }, []);

  if (isVehicleReport) {
    if (!vehicleResult?.complete || !vehicleResult?.report) throw new Error("گزارش خودرو در دسترس نیست");
    return <section ref={sectionRef} className="relative z-10 mb-40 mt-[-116px] w-full"><AppContainer className="h-auto max-w-[70rem]"><VehicleComprehensiveReport {...vehicleResult} code={vehiclePurchase.code} input={vehiclePurchase.user_input} createdAt={vehiclePurchase.created_at} /></AppContainer></section>;
  }

  if (!matched) throw new Error("درخواست ناموفق بود");

  if (!matched.render(purchasedInquiryData))
    throw new Error("درخواست ناموفق بود");

  return (
    <section
      ref={sectionRef}
      className="flex-column relative z-10 mt-[-116px] mb-40 min-h-52 w-full"
    >
      <AppContainer className={cn("size-full max-w-[70rem] grow")}>
        <FlexCenter className="size-full">
          <Suspense>{matched.render(purchasedInquiryData)}</Suspense>
        </FlexCenter>
        <SaveBillFromInquiry data={purchasedInquiryData} />
        <div className="mx-auto mt-10 max-w-[500px] rounded-md border border-amber-400 bg-amber-400/20 p-2 text-sm leading-6 text-gray-950 lg:max-w-[640px]">
          <h3>🔒 امنیت و حریم خصوصی اطلاعات شما در نوین وان</h3>
          <p>
            به‌منظور حفظ امنیت و حریم شخصی کاربران،
            <strong>
              اطلاعات استعلام شما در سامانه نوین وان ذخیره نمی‌شود.
            </strong>
          </p>
          <p>
            گزارش فعلی فقط تا <strong>۲۴ ساعت آینده</strong> از طریق حساب کاربری
            شما قابل مشاهده است و پس از آن،
            <strong>به‌صورت خودکار حذف می‌گردد.</strong>
          </p>
          <p>
            بنابراین توصیه می‌شود برای نگهداری نسخه‌ای از نتیجه استعلام خود، از
            گزینه &nbsp;
            <strong>دانلود PDF</strong> استفاده کنید تا گزارش در دستگاه شما
            ذخیره شود.
          </p>
          <p>
            توجه داشته باشید که در بخش تاریخچه، فقط{" "}
            <strong>عنوان استعلام</strong> باقی می‌ماند و محتوای جزئیات آن دیگر
            قابل نمایش نخواهد بود.
          </p>
        </div>
      </AppContainer>
    </section>
  );
};

export default InquiryDetailsWrapper;
